import React from "react";
import styled from 'styled-components';

const StyledTab = styled.button`
	${(props) => props.theme.typography.heading2XS};
	font-family: inherit;
	background-color: ${(props) => props.$active ? props.theme.colors.neutral10 : props.theme.colors.purple4};
	border: 1px solid ${(props) => props.$active ? props.theme.colors.neutral6 : 'transparent'};
	border-bottom-color: ${(props) => props.$active ? props.theme.colors.neutral10 : 'transparent'};
	border-radius: 0.25rem 0.25rem 0 0;
	color: ${(props) => props.$active ? props.theme.colors.neutral1 : props.theme.colors.neutral10};
	cursor: pointer;
	margin-bottom: -1px;
	padding: 0.75rem 1.25rem;
	position: relative;
	text-align: center;
	text-transform: uppercase;
	z-index: ${(props) => props.$active ? 1 : 0};

	&:hover {
		background-color: ${(props) => props.$active ? props.theme.colors.neutral10 : props.theme.colors.purple3 };
		border-color: ${(props) => props.$active ? props.theme.colors.neutral6 : 'transparent'};
		border-bottom-color: ${(props) => props.$active ? props.theme.colors.neutral10 : 'transparent'};
	}

	&:focus-visible {
		outline: 2px solid ${(props) => props.theme.colors.purple4};
		outline-offset: 2px;
	}
`;

export function Tab({ active, children, ...props }) {
	return <StyledTab type="button" $active={active} {...props}>{children}</StyledTab>;
}